import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { DataService } from '../service/data.service';
import { ApiService } from '../custom-services/ApiService';
import { environment } from '../../environments/environment';
import { ToastrService } from 'ngx-toastr';
import {PageContentManual} from "../page-content-manual";

import { Location } from '@angular/common';

@Component({
    selector: 'app-special-registration-manual',
    templateUrl: './special-registration-manual.html',
    styleUrls: ['./special-registration-manual.css'],
    standalone: false
})
export class SpecialRegistrationManualComponent implements OnInit {

  languageList = require('../page-content-manual').languageList;
  content = require("../page-content-manual").content;
  pdfSrcEN="assets/user-manual/Special_Registration.pdf";



  constructor(private router:Router,
    private location: Location) { }
  isLoading: boolean = true;
  EN:boolean = true;
  BN:boolean = false;


  ngOnInit(): void {

  }
  onBacktoMainPage() {
    // localStorage.clear();
    // this.router.navigate(["/auth/sign-up"]);
    this.location.back();
  }

  afterLoadComplete(pdf: any) {
    this.isLoading = false;
    console.log("spinner working");
  }
}
